import Cookies from 'js-cookie';

const COOKIES_PARAMS = {
  'abp-account-manager': 'accountManager'
};

export function getCookie(name) {
  return Cookies.get(name);
}

export function setCookie(name, value) {
  if (value) {
    Cookies.set(name, value, { path: '/', secure: true });
  }
}

export function deleteCookie(name) {
  Cookies.remove(name);
}

export const addCookieParam = (url, cookieName) => {
  const cookieValue = getCookie(cookieName);
  if (!cookieValue) return url;

  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}${COOKIES_PARAMS[cookieName] ?? cookieName}=${cookieValue}`;
};
